/* AYO homepage sections: tabs, featured product quick add, lookbook hotspots. */
if (!customElements.get('ayo-tabs')) {
  class AyoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.more = this.querySelector('[data-ayo-more]');
      this.btn = this.querySelector('[data-ayo-tab-btn]');
      this.btnLabel = this.querySelector('[data-ayo-tab-btn-label]');
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const next = rtl ? 'ArrowLeft' : 'ArrowRight';
          const prev = rtl ? 'ArrowRight' : 'ArrowLeft';
          if (e.key === next || e.key === prev) {
            e.preventDefault();
            const j = (i + (e.key === next ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(j);
            this.tabs[j].focus();
          }
        });
      });
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.tabs.indexOf(e.target.closest && e.target.closest('[role="tab"]'));
        if (i > -1) this.select(i);
      });
    }

    select(i) {
      this.tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on) { const row = panel.querySelector('.ayo-row'); if (row) row.scrollLeft = 0; }
        }
      });
      const t = this.tabs[i];
      if (this.more && t.dataset.url) this.more.setAttribute('href', t.dataset.url);
      if (this.btn && t.dataset.url) this.btn.setAttribute('href', t.dataset.url);
      if (this.btnLabel && t.dataset.btn) this.btnLabel.textContent = t.dataset.btn;
    }
  }
  customElements.define('ayo-tabs', AyoTabs);
}

if (!customElements.get('ayo-buy')) {
  class AyoBuy extends HTMLElement {
    connectedCallback() {
      this.sizes = Array.from(this.querySelectorAll('[data-variant-id]'));
      this.add = this.querySelector('[data-ayo-buy-add]');
      this.msg = this.querySelector('[data-ayo-buy-msg]');
      this.cfg = JSON.parse((this.querySelector('[data-ayo-buy-config]') || {}).textContent || '{}');
      this.variant = this.dataset.singleVariant || null;
      this.sizes.forEach((b) => b.addEventListener('click', () => this.pick(b)));
      if (this.add) this.add.addEventListener('click', () => this.buy());
      this.paint();
    }

    pick(b) {
      this.sizes.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      this.variant = b.dataset.variantId;
      this.say('');
      this.paint();
    }

    paint() {
      if (!this.add) return;
      const picked = this.sizes.find((x) => x.getAttribute('aria-pressed') === 'true');
      this.add.classList.toggle('is-waiting', !this.variant);
      this.add.textContent = picked
        ? (this.cfg.addSize || '').replace('%size%', picked.textContent.trim())
        : (this.variant ? this.cfg.add : this.cfg.pick) || '';
    }

    say(text, ok) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.hidden = !text;
      this.msg.classList.toggle('is-ok', !!ok);
    }

    async buy() {
      if (!this.variant) { this.say(this.cfg.pickFirst || '', false); return; }
      if (this.add.classList.contains('is-loading')) return;
      this.add.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData();
      fd.append('id', this.variant);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
        fd.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        });
        const data = await res.json();
        if (data.status) { this.say(data.description || this.cfg.error, false); return; }
        this.say(this.cfg.added, true);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-featured', productVariantId: this.variant, cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (e) {
        this.say(this.cfg.error, false);
      } finally {
        this.add.classList.remove('is-loading');
      }
    }
  }
  customElements.define('ayo-buy', AyoBuy);
}

if (!customElements.get('ayo-look')) {
  class AyoLook extends HTMLElement {
    connectedCallback() {
      this.spots = Array.from(this.querySelectorAll('[data-ayo-spot]'));
      this.cards = Array.from(this.querySelectorAll('[data-ayo-look-card]'));
      this.spots.forEach((s, i) => s.addEventListener('click', () => this.show(i)));
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.spots.indexOf(e.target.closest && e.target.closest('[data-ayo-spot]'));
        if (i > -1) this.show(i);
      });
    }

    show(i) {
      this.spots.forEach((s, j) => s.setAttribute('aria-pressed', i === j ? 'true' : 'false'));
      this.cards.forEach((c, j) => { c.hidden = i !== j; });
    }
  }
  customElements.define('ayo-look', AyoLook);
}
